import { Info } from 'lucide-react';
import { Badge, Button, Tooltip, TooltipContent, TooltipTrigger } from '@shigo-ui/ui';

import { dashboardT } from '../../../../../lib/messages';
import type { TailoredSupplyItem } from '../../model';

export function TailoredSupplyNameCell({ item }: { item: TailoredSupplyItem }) {
  return (
    <span className="flex min-w-0 items-center gap-2">
      <span className="min-w-0 truncate">{item.name}</span>
      {item.description ? (
        <Tooltip delayDuration={0}>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon"
              className="text-muted-foreground hover:text-foreground h-7 w-7 shrink-0"
              aria-label={dashboardT('tailoredSupply.info', { name: item.name })}
            >
              <Info className="h-3.5 w-3.5" aria-hidden="true" />
            </Button>
          </TooltipTrigger>
          <TooltipContent side="top" className="max-w-80 whitespace-pre-wrap">
            {item.description}
          </TooltipContent>
        </Tooltip>
      ) : null}
    </span>
  );
}

export function TailoredSupplyBadgeList({
  values,
  variant,
}: {
  values: string[];
  variant: 'neutral' | 'error' | 'info';
}) {
  if (!values.length) return <span>-</span>;
  return (
    <span className="flex flex-wrap gap-1">
      {values.map((value) => (
        <Badge key={value} variant={variant} className="rounded-full px-2 py-0.5">
          {value}
        </Badge>
      ))}
    </span>
  );
}
